export default function ApplicationProcess() {
  const steps = [
    {
      step: 'Step 01',
      title: 'Fill Out the Application Form',
      description:
        'Isi formulir agar kami memahami background dan pengalamanmu sebelumnya.',
    },
    {
      step: 'Step 02',
      title: 'Interview Call',
      description:
        'Video call dengan Admission Counselor untuk memastikan ekspektasi dan tujuanmu sesuai dengan program ini.',
    },
    {
      step: 'Step 03',
      title: 'Admission Result Announcement',
      description: 'Dapatkan notifikasi mengenai hasil seleksi penerimaanmu.',
    },
  ]

  return (
    <section className="bg-gray-100 pb-16">
      <div className="mb-16 bg-red-700 py-10 text-center">
        <h2 className="text-3xl font-bold text-white">
          Ready to Take the Next Step?
        </h2>
      </div>

      <div className="max-w-8xl mx-auto px-6">
        <h3 className="mb-10 text-center text-3xl font-bold text-gray-700">
          Application Process
        </h3>

        <div className="flex justify-center">
          <div className="w-full max-w-5xl rounded-xl border border-gray-300 bg-white px-12 py-8">
            <div className="relative mb-8 w-full rounded-lg bg-red-600 bg-gradient-to-r from-red-800 to-red-600 p-9 sm:w-[100%] md:w-[95%]">
              <div className="text-2xl font-bold text-white">
                N3 Ready Bootcamp
                <br />+ Work Preparation
              </div>
              <img
                src="/img/gijinkoku/Group797.png"
                alt="Program illustration"
                className="absolute -right-12 top-0 hidden h-auto w-32 md:block"
              />
            </div>

            <div className="space-y-6">
              {steps.map((step, index) => (
                <div key={index} className="flex gap-6 p-2">
                  <div className="flex h-10 w-20 items-center justify-center rounded border border-gray-300 bg-red-600 px-2">
                    <div className="text-sm font-bold text-white">
                      {step.step}
                    </div>
                  </div>
                  <div className="flex-1">
                    <div className="mb-1 text-base font-bold text-gray-700">
                      {step.title}
                    </div>
                    <div className="text-sm text-gray-700">
                      {step.description}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
